

// export const V_URL = process.env.REACT_APP_API_URL;
export const V_URL = process.env.REACT_APP_PRODUCTION_URL;


export const PAY = "Payroll System";
export const M_STORE = "Main Store";
export const P_STORE = "Project Store";
export const ERP = "Project Fabrication";

export const PLAN = 'Planning Engineer';
export const QC = 'QC Engineer';
export const M_CON = 'Material Controller';
export const PRODUCTION = 'Production Engineer';
export const WELD = 'Welding Engineer';
export const PAINT = 'Painting Engineer';
export const QA = 'QA Engineer';

export const PMS = 'Project Fabrication';

export const CENTRAL_PLAN = "Central Planning"
export const PO_PLAN = "Procurement"